import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import CustomizerHeader from './Header.vue';
import { useCustomizer } from '~/composables/_next/stores/useCustomizerStore';
import { CUSTOMIZER_BANNER_URL } from '~/constants';
import { useCustomizerInit } from '~/composables/initCustomizerLogic';
import AzLoader from '~/components/_next/atoms/AzLoader.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup: function setup(__props) {
    var _useCustomizerInit = useCustomizerInit(),
      initNeutralBaseCustomizer = _useCustomizerInit.initNeutralBaseCustomizer;
    var CustomizerFooter = function CustomizerFooter() {
      return import('./Footer.vue');
    };
    var CustomizerStep1 = function CustomizerStep1() {
      return import('./Step1.vue');
    };
    var CustomizerStep2 = function CustomizerStep2() {
      return import('./Step2.vue');
    };
    var CustomizerStep3 = function CustomizerStep3() {
      return import('./Step3.vue');
    };
    var CustomizerStep4 = function CustomizerStep4() {
      return import('./Step4.vue');
    };
    var CustomizerStep5 = function CustomizerStep5() {
      return import('./Step5.vue');
    };
    var CustomizerStep6 = function CustomizerStep6() {
      return import('./Step6.vue');
    };
    var CustomizerStep7 = function CustomizerStep7() {
      return import('./Step7.vue');
    };
    var CustomizerProductOverlay = function CustomizerProductOverlay() {
      return import('./ProductOverlay.vue');
    };
    var Email = function Email() {
      return import('./Email.vue');
    };
    var AzImg = function AzImg() {
      return import('~/components/Atoms/AzImg.vue');
    };
    var _useCustomizer = useCustomizer(),
      customizer = _useCustomizer.customizer,
      closeCustomizer = _useCustomizer.closeCustomizer,
      initializeCustomizerStep = _useCustomizer.initializeCustomizerStep;
    initializeCustomizerStep();
    var customizerMainImage = CUSTOMIZER_BANNER_URL;
    var router = useRouter();
    var route = useRoute();
    var _useUiState = useUiState(),
      isCartSidebarOpen = _useUiState.isCartSidebarOpen,
      toggleCartSidebar = _useUiState.toggleCartSidebar;
    var _useScrollLock = useScrollLock(),
      lockScroll = _useScrollLock.lockScroll,
      unlockScroll = _useScrollLock.unlockScroll;
    var mainImage = computed(function () {
      var _customizer$value$neu, _customizer$value$neu2, _customizer$value$neu3, _customizer$value$neu4;
      return customizer.value.neutralBase && customizer.value.step > 1 ? (_customizer$value$neu = customizer.value.neutralBase) === null || _customizer$value$neu === void 0 ? void 0 : (_customizer$value$neu2 = _customizer$value$neu.product) === null || _customizer$value$neu2 === void 0 ? void 0 : (_customizer$value$neu3 = _customizer$value$neu2.images) === null || _customizer$value$neu3 === void 0 ? void 0 : (_customizer$value$neu4 = _customizer$value$neu3[0]) === null || _customizer$value$neu4 === void 0 ? void 0 : _customizer$value$neu4.url : customizerMainImage;
    });
    var currentStepComponent = computed(function () {
      var componentMap = {
        1: CustomizerStep1,
        2: CustomizerStep2,
        3: CustomizerStep3,
        4: CustomizerStep4,
        5: CustomizerStep5,
        6: CustomizerStep6,
        7: CustomizerStep7
      };
      var component = componentMap[customizer.value.step];
      if (!component) {
        throw new Error('Invalid step number');
      }
      return component;
    });
    var onOverlayClick = function onOverlayClick() {
      closeCustomizer();
      if (customizer.value.step > 1 && !(isCartSidebarOpen !== null && isCartSidebarOpen !== void 0 && isCartSidebarOpen.value)) toggleCartSidebar();
    };
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            lockScroll();
            _context.next = 3;
            return initNeutralBaseCustomizer();
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    onUnmounted(function () {
      unlockScroll();
      if (route.fullPath.includes('#customizer')) router.push(route.fullPath.replace('#customizer', ''));
    });
    return {
      __sfc: true,
      initNeutralBaseCustomizer: initNeutralBaseCustomizer,
      CustomizerFooter: CustomizerFooter,
      CustomizerStep1: CustomizerStep1,
      CustomizerStep2: CustomizerStep2,
      CustomizerStep3: CustomizerStep3,
      CustomizerStep4: CustomizerStep4,
      CustomizerStep5: CustomizerStep5,
      CustomizerStep6: CustomizerStep6,
      CustomizerStep7: CustomizerStep7,
      CustomizerProductOverlay: CustomizerProductOverlay,
      Email: Email,
      AzImg: AzImg,
      customizer: customizer,
      closeCustomizer: closeCustomizer,
      initializeCustomizerStep: initializeCustomizerStep,
      customizerMainImage: customizerMainImage,
      router: router,
      route: route,
      isCartSidebarOpen: isCartSidebarOpen,
      toggleCartSidebar: toggleCartSidebar,
      lockScroll: lockScroll,
      unlockScroll: unlockScroll,
      mainImage: mainImage,
      currentStepComponent: currentStepComponent,
      onOverlayClick: onOverlayClick,
      CustomizerHeader: CustomizerHeader,
      AzLoader: AzLoader
    };
  }
});